export default {"src":"/_next/static/media/icon-farmhouseSemiDetached.0ba42d39.svg","height":22,"width":30,"blurWidth":0,"blurHeight":0};